import { PIPELINE_TOOL_NAMES } from '@kw/quokka-ui';

export const getReviewActionOptions = (hasPermission: boolean, setReviewModalMode: (mode: 'single' | 'all' | null) => void) =>
  hasPermission
    ? [
        {
          label: 'Review for Selected Version',
          value: 'review_for_selected_version',
          onClick: () => setReviewModalMode('single'),
        },
        {
          label: 'Review for Future Versions',
          value: 'review_for_future_versions',
          onClick: () => setReviewModalMode('all'),
        },
      ]
    : [];

export const getCategoryFromRuleId = ruleId => {
  const parts = ruleId.split('/');
  if (parts[0] === 'profile' || parts[0] === 'audit') {
    return parts[1] || parts[0];
  }
  return parts[0];
};

export const isBehavioral = ruleSummary =>
  (ruleSummary.rule?.tool === PIPELINE_TOOL_NAMES.pattern ||
    ruleSummary.rule?.tool === `${PIPELINE_TOOL_NAMES.pattern}-ios` ||
    ruleSummary.rule?.tool === PIPELINE_TOOL_NAMES.permission) &&
  ruleSummary.rule?.id?.startsWith('profile');
